"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Table_1 = require("@sportnet/ui/lib/Table");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var Tooltip_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Tooltip"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var StyledTr = styled_components_1["default"](Table_1.Tr)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  :hover > td {\n    background: inherit;\n  }\n"], ["\n  :hover > td {\n    background: inherit;\n  }\n"])));
var Condition = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ConditionItem = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  background: ", ";\n  color: white;\n"], ["\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  background: ", ";\n  color: white;\n"])), polished_1.rem(24), polished_1.rem(24), polished_1.rem(12), function (_a) {
  var theme = _a.theme,
      result = _a.result;

  if (result === 'W') {
    return theme.color.success;
  } else if (result === 'D') {
    return theme.color.warning;
  } else if (result === 'L') {
    return theme.color.danger;
  }

  return theme.color.primary;
});

var WidgetResultsTable = function (_a) {
  var data = _a.data,
      renderEmpty = _a.renderEmpty;

  var _b = React.useState([]),
      highlightedTeams = _b[0],
      setHighlightedTeams = _b[1];

  var getResultLabel = function (result) {
    switch (result) {
      case 'W':
        return 'V';

      case 'D':
        return 'R';

      case 'L':
        return 'P';

      default:
        return '';
    }
  };

  var getTeamCondition = function (result) {
    var lastFive = tslib_1.__spreadArrays(result.matches || []).reverse().slice(0, 5);

    return lastFive.map(function (m) {
      var matchLabel = (m.homeaway === 'home' ? result.team && result.team.name : m.team.name) + " - " + (m.homeaway === 'away' ? result.team && result.team.name : m.team.name);
      return React.createElement(Tooltip_1["default"], {
        key: matchLabel,
        content: React.createElement("div", null, React.createElement("b", null, m.score), " (", matchLabel, ")")
      }, React.createElement("div", {
        style: {
          padding: "0 " + polished_1.rem(2)
        },
        onMouseEnter: function () {
          if (result.team) {
            setHighlightedTeams([result.team._id, m.team._id]);
          }
        },
        onMouseLeave: function () {
          setHighlightedTeams([]);
        }
      }, React.createElement(ConditionItem, {
        result: m.result
      }, getResultLabel(m.result))));
    });
  };

  if ((!data.competitionId || !data.partId) && renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('resultsTable'));
  }

  return React.createElement(React.Fragment, null, React.createElement(Table_1.Table, null, React.createElement(Table_1.Thead, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Th, {
    width: 30
  }), React.createElement(Table_1.Th, null, "Klub"), React.createElement(Table_1.Th, {
    width: 30
  }, "Z"), React.createElement(Table_1.Th, {
    width: 30
  }, "V"), React.createElement(Table_1.Th, {
    width: 30
  }, "R"), React.createElement(Table_1.Th, {
    width: 30
  }, "P"), React.createElement(Table_1.Th, {
    width: 60
  }, "Sk\u00F3re"), React.createElement(Table_1.Th, {
    width: 30
  }, "B"), React.createElement(Table_1.Th, {
    width: 160
  }, "Forma"))), React.createElement(Table_1.Tbody, null, data.data && data.data.results.map(function (result, idx) {
    return React.createElement(StyledTr, {
      key: result.team._id,
      highlighted: result.team && highlightedTeams.includes(String(result.team._id))
    }, React.createElement(Table_1.Td, null, idx + 1), React.createElement(Table_1.Td, null, result.team && result.team.name), React.createElement(Table_1.Td, null, result.stats.matches.played), React.createElement(Table_1.Td, null, result.stats.matches.won), React.createElement(Table_1.Td, null, result.stats.matches.draw), React.createElement(Table_1.Td, null, result.stats.matches.lost), React.createElement(Table_1.Td, null, result.stats.goals.given, ":", result.stats.goals.received), React.createElement(Table_1.Td, null, result.stats.points), React.createElement(Table_1.Td, null, React.createElement(Condition, null, getTeamCondition(result))));
  }))));
};

exports["default"] = WidgetResultsTable;
var templateObject_1, templateObject_2, templateObject_3;